import React, { useEffect, useState } from 'react';
import { has, is } from '../../services';
import { getBackgroundClassName } from '../../objects';
import clsx from 'clsx';
import { hashClass } from '../../helpers';
import { useTrilogyContext } from '../../context';
/**
 * Section Component - Manages the main margins of the page and takes up all the available width.
 * @param className {string} Additionnal CSS Classes
 * @param skeleton {boolean} Skeleton before loaded
 * @param children {React.ReactNode}
 * @param background {TrilogyColor} Section Background Color
 * @param backgroundSrc {string} Source of background Image
 * @param paddingless {boolean} remove padding
 * @param verticalPaddingless {boolean} remove vertical padding
 **/
const Section = ({ className, skeleton, size, background, backgroundSrc, paddingless, verticalPaddingless, fullwidth, ...others }) => {
    const { styled } = useTrilogyContext();
    const [isLoading, setIsLoading] = useState(skeleton || false);
    useEffect(() => {
        setIsLoading(skeleton || false);
    }, [skeleton]);
    const _className = hashClass(styled, clsx('section', className, isLoading ? is('loading') : is('loaded'), size && is(size), fullwidth && is('fullwidth'), paddingless && is('paddingless'), verticalPaddingless && is('vertical-paddingless'), background && has(getBackgroundClassName(background)), backgroundSrc && has('background')));
    return (React.createElement("section", { ...(backgroundSrc && {
            style: { backgroundImage: `url(${backgroundSrc})`, backgroundSize: 'cover', backgroundPosition: '50%' },
        }), className: _className, ...others }));
};
export default Section;
//# sourceMappingURL=Section.js.map